import { useState, useEffect, useCallback } from 'react';
import { panelsApi } from '../api';

export function usePanels(filters = {}) {
  const [panels, setPanels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPanels = useCallback(async (background = false) => {
    if (!background) setLoading(true);
    try {
      const { data } = await panelsApi.list(filters);
      setPanels(data.panels);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch panels');
    } finally {
      if (!background) setLoading(false);
    }
  }, [JSON.stringify(filters)]);

  useEffect(() => {
    fetchPanels();
  }, [fetchPanels]);

  return { panels, loading, error, refetch: fetchPanels };
}
